// El sobre del swiper (ADR 193, F1).
//
// Se apagó en F0 porque la ruta vieja —`generate-swiper-discount`— emitía un
// descuento por el 100% del precio de una carta al azar sin verificar nada, y el
// candado de los $200 vivía en este archivo. La orden #VA-1869 cerró en $0.00
// con uno de esos códigos.
//
// Vuelve encendido contra `/api/swiper/premio`, que es otra cosa: la compra
// mínima la exige Shopify en el checkout (BXGY), el código dura 72 horas, hay
// cuota por IP y presupuesto diario, y el servidor aparta la copia exacta que se
// sorteó para no regalar la carta de otro vendedor.
//
// Nada de eso se decide aquí. Este archivo solo pinta el progreso y pide el
// sobre; el umbral se pregunta, no se cablea.
const PREMIO_SWIPER_ACTIVO = true;
const API_DEL_SOBRE = 'https://cards.the-vault.mx/api/swiper/premio';
const IMAGEN_DE_RESPALDO =
  'https://cdn.shopify.com/s/files/1/0664/7218/1944/files/gift-card-placeholder.jpg?v=1752181051';

class ProductSwiper {
  constructor() {
    this.container = document.getElementById('product-swiper');
    this.trigger = document.getElementById('product-swiper-trigger');
    this.closeButton = document.getElementById('product-swiper-close');
    this.cardsContainer = document.getElementById('product-swiper-container');
    
    this.products = [];
    this.currentIndex = 0;
    
    // Properties for randomization
    this.allProducts = window.allProducts || [];
    this.currentProducts = [];
    
    // Properties for pagination
    this.paginationInfo = window.paginationInfo || {};
    this.isLoadingMoreProducts = false;
    this.loadMoreThreshold = 2; // Load more when 2 cards left
    
    // El sobre (ADR 193 F1). `compraMinima` llega del servidor: cablearla es
    // exactamente lo que hizo que el candado viviera en el navegador.
    this.swipedToCartCount = 0;
    this.totalSwipedValue = 0;
    this.compraMinima = null;
    this.hayPool = false;
    this.rewardEarned = false;
    
    this.init();
  }

  init() {
    this.bindEvents();
    // Swiper will be initialized when modal opens
  }

  bindEvents() {
    // Trigger button
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.open());
    }
    
    // Close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }
    
    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });
    
    // Close on backdrop click
    if (this.container) {
      this.container.addEventListener('click', (e) => {
        if (e.target === this.container) {
          this.close();
        }
      });
    }
  }

  loadProducts() {
    // Initialize Tinder-style swiper
    this.initializeTinderSwiper();
  }

  initializeTinderSwiper() {
    console.log('Initializing Tinder swiper with randomization');
    console.log('Total products available:', this.allProducts.length);
    
    if (this.allProducts.length === 0) {
      console.log('No products available, showing empty state');
      this.showEmptyState();
      return;
    }
    
    // Get random 20 products
    this.currentProducts = this.shuffleArray([...this.allProducts]).slice(0, 20);
    console.log('Selected random products:', this.currentProducts.length);
    
    // Log first few products to verify price data
    console.log('=== PRODUCT PRICE VERIFICATION ===');
    this.currentProducts.slice(0, 3).forEach((product, index) => {
      console.log(`Product ${index}:`, {
        id: product.id,
        title: product.title,
        price_cents: product.price,
        price_dollars: product.price / 100
      });
    });
    
    // Get existing cards and update their data
    this.cards = document.querySelectorAll('.tinder-card');
    
    // Update card data with random products
    this.cards.forEach((card, index) => {
      if (this.currentProducts[index]) {
        const product = this.currentProducts[index];
        card.dataset.productId = product.id;
        card.dataset.variantId = product.variant_id;
        card.dataset.productIndex = index;
        
        // Update image with smooth transition
        const imgElement = card.querySelector('.product-image');
        const placeholder = card.querySelector('.image-placeholder');
        const imageContainer = card.querySelector('[style*="opacity: 0"]');
        
        if (imgElement && product.featured_image) {
          // Set the new image
          imgElement.src = product.featured_image;
          imgElement.alt = product.title;
          
          // Wait for image to load, then fade in
          imgElement.onload = () => {
            // Fade out placeholder
            if (placeholder) {
              placeholder.style.opacity = '0';
              setTimeout(() => {
                placeholder.style.display = 'none';
              }, 300);
            }
            
            // Fade in product image
            imgElement.style.opacity = '1';
            
            // Fade in the entire container
            if (imageContainer) {
              imageContainer.style.opacity = '1';
            }
          };
        }
        
        // Update price
        const priceElement = card.querySelector('[style*="background: #ffd700"]');
        if (priceElement) {
          const price = this.formatMoney(product.price);
          const comparePrice = product.compare_at_price > 0 ? this.formatMoney(product.compare_at_price) : null;
          priceElement.innerHTML = comparePrice ? 
            `<span style="text-decoration: line-through; color: #999; font-size: 1.2rem; margin-right: 8px;">${comparePrice}</span>${price}` :
            price;
        }
      }
    });
    
    this.currentCardIndex = 0;
    this.isDragging = false;
    this.isSwiping = false;
    this.startX = 0;
    this.startY = 0;
    this.currentX = 0;
    this.currentY = 0;
    
    console.log('Tinder swiper initialized with', this.cards.length, 'cards');
    
    if (this.cards.length === 0) {
      console.log('No cards found, showing empty state');
      this.showEmptyState();
      return;
    }
    
    // Show first card
    this.showCurrentCard();
    
    // Add event listeners
    this.addCardEventListeners();
    this.addButtonEventListeners();
    
    console.log('Tinder swiper setup complete');
  }

  showCurrentCard() {
    console.log('=== SHOWING CARD ===');
    console.log('Current card index:', this.currentCardIndex);
    console.log('Total cards:', this.cards.length);
    
    // Add smooth transitions to all cards
    this.cards.forEach(card => {
      card.style.transition = 'all 0.3s ease-out';
    });
    
    // Hide all cards
    this.cards.forEach((card, index) => {
      if (index < this.currentCardIndex) {
        card.style.display = 'none';
        card.style.zIndex = '0';
        console.log(`Card ${index}: HIDDEN (past)`);
      } else if (index === this.currentCardIndex) {
        card.style.display = 'block';
        // Start with a slight scale down and fade in
        card.style.transform = 'scale(0.95) translateY(10px)';
        card.style.opacity = '0';
        card.style.zIndex = '10';
        console.log(`Card ${index}: MAIN (current)`);
        
        // Animate to final position
        setTimeout(() => {
          card.style.transform = 'scale(1) translateY(0)';
          card.style.opacity = '1';
        }, 50);
      } else if (index === this.currentCardIndex + 1) {
        // Show only the next card behind
        card.style.display = 'block';
        card.style.transform = 'scale(0.95) translateY(10px)';
        card.style.opacity = '0.7';
        card.style.zIndex = '5';
        console.log(`Card ${index}: BACKGROUND (next)`);
      } else {
        // Hide all other cards
        card.style.display = 'none';
        card.style.zIndex = '0';
        console.log(`Card ${index}: HIDDEN (future)`);
      }
    });
    
    console.log('=== END SHOWING CARD ===');
    
    // Update event listeners for the new current card
    this.updateCardEventListeners();
  }

  addCardEventListeners() {
    // Add event listeners to the current card only
    this.updateCardEventListeners();
  }

  updateCardEventListeners() {
    console.log('Updating event listeners for card', this.currentCardIndex);
    
    // Remove old listeners
    if (this.dragBound) {
      document.removeEventListener('mousemove', this.dragBound);
      document.removeEventListener('mouseup', this.endDraggingBound);
      document.removeEventListener('touchmove', this.dragBound);
      document.removeEventListener('touchend', this.endDraggingBound);
    }
    
    // Bind methods to preserve context
    this.dragBound = this.drag.bind(this);
    this.endDraggingBound = this.endDragging.bind(this);
    
    // Add listeners to current card
    const currentCard = this.cards[this.currentCardIndex];
    if (currentCard) {
      console.log('Adding event listeners to current card');
      currentCard.addEventListener('mousedown', (e) => this.startDragging(e));
      currentCard.addEventListener('touchstart', (e) => this.startDragging(e));
      
      // Global listeners for drag and end
      document.addEventListener('mousemove', this.dragBound);
      document.addEventListener('mouseup', this.endDraggingBound);
      document.addEventListener('touchmove', this.dragBound);
      document.addEventListener('touchend', this.endDraggingBound);
    } else {
      console.log('No current card found');
    }
  }

  addButtonEventListeners() {
    console.log('Adding button event listeners');
    
    // Like button
    document.querySelectorAll('.like-btn').forEach(btn => {
      // Remove existing listeners to prevent duplicates
      btn.removeEventListener('click', this.likeCardBound);
      btn.removeEventListener('click', this.dislikeCardBound);
      
      // Add new listener
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        console.log('Like button clicked!');
        this.likeCard();
      });
    });
    
    // Dislike button
    document.querySelectorAll('.dislike-btn').forEach(btn => {
      // Remove existing listeners to prevent duplicates
      btn.removeEventListener('click', this.likeCardBound);
      btn.removeEventListener('click', this.dislikeCardBound);
      
      // Add new listener
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        console.log('Dislike button clicked!');
        this.dislikeCard();
      });
    });
  }

  startDragging(e) {
    console.log('Start dragging');
    
    // Check if the click was on a button or its children
    const clickedElement = e.target;
    if (clickedElement.closest('.like-btn') || clickedElement.closest('.dislike-btn') || 
        clickedElement.classList.contains('like-btn') || clickedElement.classList.contains('dislike-btn')) {
      console.log('Click was on a button, ignoring drag');
      return;
    }
    
    if (this.currentCardIndex >= this.cards.length) return;
    
    this.isDragging = true;
    this.startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
    this.startY = e.type === 'mousedown' ? e.clientY : e.touches[0].clientY;
    
    const currentCard = this.cards[this.currentCardIndex];
    currentCard.style.cursor = 'grabbing';
  }

  drag(e) {
    if (!this.isDragging) return;
    
    e.preventDefault();
    
    // Double check we're not on a button
    if (this.startX === 0 && this.startY === 0) {
      this.isDragging = false;
      return;
    }
    
    this.currentX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
    this.currentY = e.type === 'mousemove' ? e.clientY : e.touches[0].clientY;
    
    const deltaX = this.currentX - this.startX;
    const deltaY = this.currentY - this.startY;
    
    const currentCard = this.cards[this.currentCardIndex];
    if (currentCard) {
      // Calculate rotation and scale based on drag distance
      const rotation = deltaX * 0.15;
      const scale = 1 - Math.abs(deltaX) * 0.0005;
      
      currentCard.style.transform = `translate(${deltaX}px, ${deltaY}px) rotate(${rotation}deg) scale(${scale})`;
      
      // Add color based on direction
      if (deltaX > 50) {
        currentCard.style.border = '3px solid #2ed573';
      } else if (deltaX < -50) {
        currentCard.style.border = '3px solid #ff4757';
      } else {
        currentCard.style.border = 'none';
      }
    }
  }

  endDragging() {
    if (!this.isDragging) return;
    
    console.log('End dragging');
    
    // Check if the click was on a button
    if (this.startX === 0 && this.startY === 0) {
      console.log('No drag detected, ignoring');
      this.isDragging = false;
      return;
    }
    
    this.isDragging = false;
    
    const currentCard = this.cards[this.currentCardIndex];
    if (!currentCard) return;
    
    const deltaX = this.currentX - this.startX;
    const threshold = 100;
    
    if (Math.abs(deltaX) > threshold) {
      // Swipe completed
      if (deltaX > 0) {
        this.likeCard();
      } else {
        this.dislikeCard();
      }
    } else {
      // Return to center
      currentCard.style.transform = 'translate(0, 0) rotate(0deg)';
      currentCard.style.border = 'none';
    }
    
    currentCard.style.cursor = 'grab';
  }

  likeCard() {
    console.log('=== LIKE CARD ===');
    // Stop any ongoing drag
    this.isDragging = false;
    
    // Add current product to cart
    this.addProductToCart();
    
    this.swipeCard('right');
  }

  dislikeCard() {
    console.log('=== DISLIKE CARD ===');
    // Stop any ongoing drag
    this.isDragging = false;
    this.swipeCard('left');
  }

  swipeCard(direction) {
    console.log('=== SWIPE START ===');
    console.log('Swiping card', this.currentCardIndex, 'to', direction);
    console.log('Total cards:', this.cards.length);
    
    if (this.currentCardIndex >= this.cards.length) {
      console.log('No more cards to swipe');
      return;
    }
    
    // Prevent multiple swipes
    if (this.isSwiping) {
      console.log('Already swiping, ignoring');
      return;
    }
    
    this.isSwiping = true;
    
    const currentCard = this.cards[this.currentCardIndex];
    const nextCard = this.cards[this.currentCardIndex + 1];
    const directionMultiplier = direction === 'right' ? 1 : -1;
    
    // Prepare next card before animation
    if (nextCard) {
      nextCard.style.display = 'block';
      nextCard.style.zIndex = '10';
      nextCard.style.transform = 'scale(0.95) translateY(10px)';
      nextCard.style.opacity = '0.7';
      nextCard.style.transition = 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    }
    
    // Animate current card out
    currentCard.style.transition = 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    currentCard.style.transform = `translate(${directionMultiplier * 800}px, ${directionMultiplier * 50}px) rotate(${directionMultiplier * 25}deg) scale(0.8)`;
    currentCard.style.opacity = '0';
    
    // Animate the next card coming up smoothly
    if (nextCard) {
      setTimeout(() => {
        nextCard.style.transform = 'scale(1) translateY(0)';
        nextCard.style.opacity = '1';
      }, 100);
    }
    
    // Move to next card after animation completes
    setTimeout(() => {
      console.log('=== SWIPE TIMEOUT ===');
      console.log('Moving from card', this.currentCardIndex, 'to', this.currentCardIndex + 1);
      
      this.currentCardIndex++;
      
      // Reset current card position and hide it
      currentCard.style.transition = 'none';
      currentCard.style.transform = 'translate(0, 0) rotate(0deg) scale(1)';
      currentCard.style.opacity = '1';
      currentCard.style.border = 'none';
      currentCard.style.display = 'none';
      currentCard.style.zIndex = '0';
      
      // Update event listeners without calling showCurrentCard to avoid flash
      this.updateCardEventListeners();
      
      // Check if we need to load more products
      this.checkAndLoadMoreProducts();
      
      this.isSwiping = false;
      console.log('=== SWIPE END ===');
    }, 600);
  }

  showEmptyState() {
    const container = document.getElementById('tinder-cards-container');
    const emptyState = document.getElementById('empty-state');
    
    if (container) container.style.display = 'none';
    if (emptyState) emptyState.style.display = 'block';
  }

  restart() {
    this.currentCardIndex = 0;
    this.showCurrentCard();
    
    const container = document.getElementById('tinder-cards-container');
    const emptyState = document.getElementById('empty-state');
    
    if (container) container.style.display = 'flex';
    if (emptyState) emptyState.style.display = 'none';
  }

  shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }

  async loadMoreProducts() {
    if (this.isLoadingMoreProducts || !this.paginationInfo.hasNextPage) {
      console.log('Already loading or no more pages available');
      return;
    }

    console.log('=== LOADING MORE PRODUCTS ===');
    console.log('Current page:', this.paginationInfo.currentPage);
    console.log('Next page URL:', this.paginationInfo.nextPageUrl);
    
    this.isLoadingMoreProducts = true;
    
    try {
      // For now, let's use a simpler approach: just regenerate with current products
      // This ensures we don't break the current functionality
      console.log('Regenerating current products array for better randomization');
      
      // Get new random 20 products from current pool
      this.currentProducts = this.shuffleArray([...this.allProducts]).slice(0, 20);
      console.log('Regenerated with', this.currentProducts.length, 'products');
      
      // Update card data with new random products
      this.cards.forEach((card, index) => {
        if (this.currentProducts[index]) {
          const product = this.currentProducts[index];
          card.dataset.productId = product.id;
          card.dataset.variantId = product.variant_id;
          card.dataset.productIndex = index;
          
          // Update image
          const imgElement = card.querySelector('img');
          if (imgElement && product.featured_image) {
            imgElement.src = product.featured_image;
            imgElement.alt = product.title;
          }
          
          // Update price
          const priceElement = card.querySelector('[style*="background: #ffd700"]');
          if (priceElement) {
            const price = this.formatMoney(product.price);
            const comparePrice = product.compare_at_price > 0 ? this.formatMoney(product.compare_at_price) : null;
            priceElement.innerHTML = comparePrice ? 
              `<span style="text-decoration: line-through; color: #999; font-size: 1.2rem; margin-right: 8px;">${comparePrice}</span>${price}` :
              price;
          }
        }
      });
      
      // Reset to first card
      this.currentCardIndex = 0;
      this.showCurrentCard();
      
      console.log('Successfully regenerated product set');
      
    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      this.isLoadingMoreProducts = false;
    }
  }

  checkAndLoadMoreProducts() {
    const remainingCards = this.cards.length - this.currentCardIndex;
    
    if (remainingCards <= this.loadMoreThreshold && !this.isLoadingMoreProducts) {
      console.log('=== CHECKING FOR MORE PRODUCTS ===');
      console.log('Remaining cards:', remainingCards);
      console.log('Threshold:', this.loadMoreThreshold);
      
      this.loadMoreProducts();
    }
  }

  showCurrentProduct() {
    if (this.currentIndex >= this.products.length) {
      this.showEmptyState();
      return;
    }
    
    const product = this.products[this.currentIndex];
    this.renderProductCard(product);
  }

  renderProductCard(product) {
    if (!this.cardsContainer) return;
    
    const image = product.featured_image;
    const price = product.price;
    const comparePrice = product.compare_at_price;
    
    this.cardsContainer.innerHTML = `
      <div class="product-swiper__content">
        <div class="product-card" style="background: white; border-radius: 20px; overflow: hidden; box-shadow: 0 10px 30px rgba(0,0,0,0.3); height: 100%; display: flex; flex-direction: column;">
          ${image ? 
            `<img src="${image}" alt="${product.title}" class="product-image" style="width: 100%; height: 70%; object-fit: cover;">` :
            `<div style="width: 100%; height: 70%; background: linear-gradient(45deg, #667eea 0%, #764ba2 100%); display: flex; align-items: center; justify-content: center;">
              <span style="color: white; font-size: 1.5rem; font-weight: 600;">🎴</span>
            </div>`
          }
          <div style="padding: 20px; flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
            <h3 style="margin: 0 0 10px 0; font-size: 1.3rem; color: #333; line-height: 1.3;">${product.title}</h3>
            <div style="font-size: 1.8rem; font-weight: 700; color: #000;">
              ${comparePrice && comparePrice > price ? 
                `<span style="text-decoration: line-through; color: #999; font-size: 1.2rem; margin-right: 8px;">
                  ${this.formatMoney(comparePrice)}
                </span>` : ''
              }
              ${this.formatMoney(price)}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  formatMoney(price) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(price / 100);
  }

  showEmptyState() {
    if (!this.cardsContainer) return;
    
    this.cardsContainer.innerHTML = `
      <div class="product-swiper__content">
        <h2>¡No hay más productos!</h2>
        <p>Has visto todos los productos disponibles.</p>
        <button onclick="window.productSwiper.restart()" style="background: white; color: black; border: none; padding: 12px 24px; border-radius: 25px; font-weight: 600; cursor: pointer;">
          Reiniciar
        </button>
      </div>
    `;
  }

  restart() {
    console.log('Restarting with new random products');
    
    // Reset reward tracking for new session
    this.swipedToCartCount = 0;
    this.totalSwipedValue = 0;
    this.rewardEarned = false;
    
    // Get new random 20 products
    this.currentProducts = this.shuffleArray([...this.allProducts]).slice(0, 20);
    console.log('New random products selected:', this.currentProducts.length);
    
    // Update card data with new random products
    this.cards.forEach((card, index) => {
      if (this.currentProducts[index]) {
        const product = this.currentProducts[index];
        card.dataset.productId = product.id;
        card.dataset.variantId = product.variant_id;
        card.dataset.productIndex = index;
        
        // Update image
        const imgElement = card.querySelector('img');
        if (imgElement && product.featured_image) {
          imgElement.src = product.featured_image;
          imgElement.alt = product.title;
        }
        
        // Update price
        const priceElement = card.querySelector('[style*="background: #ffd700"]');
        if (priceElement) {
          const price = this.formatMoney(product.price);
          const comparePrice = product.compare_at_price > 0 ? this.formatMoney(product.compare_at_price) : null;
          priceElement.innerHTML = comparePrice ? 
            `<span style="text-decoration: line-through; color: #999; font-size: 1.2rem; margin-right: 8px;">${comparePrice}</span>${price}` :
            price;
        }
      }
    });
    
    // Reset to first card
    this.currentCardIndex = 0;
    this.showCurrentCard();
    
    // Show container and hide empty state
    const container = document.getElementById('tinder-cards-container');
    const emptyState = document.getElementById('empty-state');
    
    if (container) container.style.display = 'flex';
    if (emptyState) emptyState.style.display = 'none';
  }

  open() {
    if (this.container) {
      this.container.classList.add('active');
      document.body.style.overflow = 'hidden';
      console.log('Product Swiper opened!');
      
      this.cargarConfigDelSobre();

      // Initialize swiper after modal is opened (when cards are available)
      setTimeout(() => {
        this.initializeTinderSwiper();
      }, 100);
    }
  }

  close() {
    if (this.container) {
      this.container.classList.remove('active');
      document.body.style.overflow = '';
      console.log('Product Swiper closed!');
    }
  }

  isOpen() {
    return this.container && this.container.classList.contains('active');
  }

  addProductToCart() {
    if (this.currentCardIndex >= this.cards.length) return;
    
    const currentCard = this.cards[this.currentCardIndex];
    const variantId = currentCard.dataset.variantId;
    
    if (!variantId) {
      console.log('No variant ID found for current card');
      return;
    }
    
    // Check if product is already in cart
    const existingCartItem = this.checkIfProductInCart(variantId);
    if (existingCartItem) {
      console.log('Product already in cart, updating quantity');
      this.updateCartItemQuantity(existingCartItem.key, existingCartItem.quantity + 1);
      return;
    }
    
    console.log('Adding variant to cart:', variantId);
    
    // Show loading state on the card
    const likeBtn = currentCard.querySelector('.like-btn');
    if (likeBtn) {
      likeBtn.innerHTML = '🛒';
      likeBtn.style.opacity = '0.7';
      likeBtn.style.transform = 'scale(0.9)';
    }
    
    // Prepare the request body
    const body = JSON.stringify({
      items: [
        {
          quantity: 1,
          id: parseInt(variantId)
        }
      ],
      sections: [
        'cart-icon-bubble',
        'cart-drawer'
      ]
    });
    
    // Add to cart using Shopify's API
    fetch(`${routes.cart_add_url}`, { 
      ...fetchConfig('javascript'), 
      body 
    })
    .then(response => response.text())
    .then(state => {
      const parsedState = JSON.parse(state);
      
      if (parsedState.description || parsedState.errors) {
        console.error('Error adding to cart:', parsedState.description);
        // Show error message
        this.showCartMessage('Error al agregar al carrito', 'error');
        return;
      }
      
      // Success! Update cart sections
      this.updateCartSections(parsedState);
      
      // Track the swipe to cart
      this.trackSwipeToCart();
      
      // Show success message
      this.showCartMessage('Agregado al carrito 🛒', 'success');
      
      console.log('Product added to cart successfully');
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      this.showCartMessage('Error al agregar al carrito', 'error');
    })
    .finally(() => {
      // Restore button state
      if (likeBtn) {
        likeBtn.innerHTML = '❤️';
        likeBtn.style.opacity = '1';
        likeBtn.style.transform = 'scale(1)';
      }
    });
  }
  
  updateCartSections(parsedState) {
    // Update cart icon bubble
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && parsedState.sections['cart-icon-bubble']) {
      cartIconBubble.innerHTML = this.getSectionInnerHTML(
        parsedState.sections['cart-icon-bubble'],
        '.shopify-section'
      );
    }
    
    // Update cart drawer
    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer && parsedState.sections['cart-drawer']) {
      cartDrawer.innerHTML = this.getSectionInnerHTML(
        parsedState.sections['cart-drawer'],
        '#CartDrawer'
      );
    }
    
    // Publish cart update event
    if (typeof publish === 'function') {
      publish('cart:updated', { source: 'product-swiper', cartData: parsedState });
    }
  }
  
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  
  // Track when a product is added to cart from swiper
  trackSwipeToCart() {
    // Get the card that was just swiped (it's the previous card now)
    const swipedCardIndex = this.currentCardIndex - 1;
    if (swipedCardIndex < 0 || swipedCardIndex >= this.cards.length) {
      console.error('Invalid card index for tracking:', swipedCardIndex);
      return;
    }
    
    const swipedCard = this.cards[swipedCardIndex];
    const productId = swipedCard.dataset.productId;
    
    // Find the product data to get the price
    const product = this.currentProducts.find(p => p.id == productId);
    if (!product) {
      console.error('Product not found in currentProducts array:', productId);
      return;
    }
    
    // Update tracking
    this.swipedToCartCount++;
    const productPrice = product.price / 100; // Convert from cents to dollars
    this.totalSwipedValue += productPrice;
    
    console.log('=== REWARDS TRACKING ===');
    console.log('Swiped card index:', swipedCardIndex);
    console.log('Current card index:', this.currentCardIndex);
    console.log('Product ID:', productId);
    console.log('Product title:', product.title);
    console.log('Product price (cents):', product.price);
    console.log('Product price (dollars):', productPrice);
    console.log('Products added to cart:', this.swipedToCartCount);
    console.log('Total value:', this.totalSwipedValue);
    console.log('Compra mínima para el sobre:', this.compraMinima);
    
    // Check for rewards
    this.checkRewards();
    
    // Update progress display
    this.updateRewardsProgress();
  }
  
  // Check if user has earned rewards
  checkRewards() {
    if (!PREMIO_SWIPER_ACTIVO) return;
    // Sin config del servidor no se promete nada: ni umbral inventado ni sobre
    // ofrecido cuando el pool no está disponible.
    if (!this.compraMinima || !this.hayPool) return;

    if (!this.rewardEarned && this.totalSwipedValue >= this.compraMinima) {
      this.rewardEarned = true;
      this.showEnvelopeAnimation();
    }
  }

  /**
   * Le pregunta al servidor cuánto hay que comprar y qué puede salir.
   *
   * Si falla, el sobre simplemente no se ofrece: `compraMinima` se queda en null
   * y `checkRewards` no dispara. Es preferible a pintar una barra con un número
   * inventado que el checkout no va a respetar.
   */
  async cargarConfigDelSobre() {
    try {
      const res = await fetch(API_DEL_SOBRE, { method: 'GET' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const config = await res.json();
      this.compraMinima = config.compraMinima || null;
      this.hayPool = config.hayPool === true;
      this.probabilidades = config.probabilidades || [];
    } catch (error) {
      console.warn('No se pudo cargar la config del sobre; no se ofrecerá:', error);
      this.compraMinima = null;
      this.hayPool = false;
    }
  }
  
  /**
   * Desglose de probabilidades del sobre (VAU-236). `this.probabilidades`
   * llega de `cargarConfigDelSobre`; si el servidor no mandó nada, no se
   * pinta nada — sin placeholder que prometa un desglose que no existe.
   */
  renderProbabilidadesHTML() {
    if (!this.probabilidades || !this.probabilidades.length) return '';

    const chips = this.probabilidades
      .map((tramo) => {
        const porcentaje = Math.round((tramo.probabilidad || 0) * 100);
        const techo = tramo.hasta === null || tramo.hasta === undefined
          ? `$${tramo.desde}+`
          : `$${tramo.desde}–$${tramo.hasta}`;
        return `
          <span title="${techo}" style="
            display: inline-flex;
            align-items: baseline;
            gap: 0.35em;
            padding: 0.3rem 0.9rem;
            border-radius: 99px;
            background: var(--vault-secondary, rgba(255,255,255,0.12));
            color: var(--vault-secondary-foreground, #fff);
            font-family: var(--vault-font-family, inherit);
            font-size: 0.95rem;
            font-weight: 600;
            white-space: nowrap;
          ">${tramo.bucket} · ${porcentaje}%</span>
        `;
      })
      .join('');

    return `
      <div class="sobre-probabilidades" style="
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 0.5rem;
        max-width: 320px;
        margin: 0 auto 20px;
      ">${chips}</div>
    `;
  }

  // Update the rewards progress display
  updateRewardsProgress() {
    if (!PREMIO_SWIPER_ACTIVO) return;
    if (!this.compraMinima || !this.hayPool) return;

    // Create or find progress container
    let progressContainer = document.getElementById('rewards-progress');
    if (!progressContainer) {
      progressContainer = document.createElement('div');
      progressContainer.id = 'rewards-progress';
      progressContainer.style.cssText = `
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(0, 0, 0, 0.8);
        backdrop-filter: blur(10px);
        border: .5px solid #ffd700;
        border-radius: 8px;
        padding: 12px 20px;
        color: white;
        font-weight: 600;
        font-size: 1.2rem;
        z-index: 999998;
        text-align: center;
        min-width: 250px;
        opacity: 0;
        transition: opacity 0.3s ease;
      `;
      document.body.appendChild(progressContainer);
    }
    
    // Calculate progress percentages
    const progress = Math.min((this.totalSwipedValue / this.compraMinima) * 100, 100);
    
    // Create progress HTML
    let progressHTML = `
      <div style="margin-bottom: 4px;">
        <div style="display: flex; justify-content: space-between; font-size: 1rem; margin-bottom: 2px;">
          <span>${this.rewardEarned ? '¡Sobre desbloqueado! 🎁' : `Agrega $${(this.compraMinima - this.totalSwipedValue).toFixed(0)} más y abre un sobre 🎁`}</span>
          <span style="color: ${this.rewardEarned ? '#2ed573' : '#ffd700'}">${this.rewardEarned ? '✅' : '🔒'}</span>
        </div>
        <div style="width: 100%; height: 8px; background: rgba(255,255,255,0.3); border-radius: 4px; overflow: hidden; border: 1px solid rgba(255,255,255,0.1);">
          <div style="width: ${progress}%; height: 100%; background: ${this.rewardEarned ? '#2ed573' : '#ffd700'}; transition: width 0.5s ease; box-shadow: 0 0 10px ${this.rewardEarned ? '#2ed573' : '#ffd700'}40;">&nbsp;</div>
        </div>
      </div>
    `;
    
    progressContainer.innerHTML = progressHTML;
    
    // Show progress
    progressContainer.style.opacity = '1';
    
    // Hide after 3 seconds
    setTimeout(() => {
      progressContainer.style.opacity = '0';
    }, 3000);
  }
  
  // Show rewards progress message
  // Show envelope animation with gift card
  showEnvelopeAnimation() {
    // Get random gift card first
    this.getRandomGiftCard().then(giftCard => {
      console.log('Gift card for envelope:', giftCard);
      console.log('Gift card image URL:', giftCard.featured_image);
      
      // Create envelope container
    let envelopeContainer = document.getElementById('envelope-container');
    if (!envelopeContainer) {
      envelopeContainer = document.createElement('div');
      envelopeContainer.id = 'envelope-container';
      envelopeContainer.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.8);
        backdrop-filter: blur(10px);
        z-index: 999999;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        transition: opacity 0.5s ease;
      `;
      document.body.appendChild(envelopeContainer);
    }

    // Get the actual logo from header
    const headerLogo = document.querySelector('.header__heading-logo');
    let logoHTML = '';
    
    if (headerLogo) {
      // Clone the logo and adjust its size for the boost pack
      const logoClone = headerLogo.cloneNode(true);
      logoClone.style.cssText = `
        max-width: 240px;
        max-height: 120px;
        width: auto;
        height: auto;
        filter: brightness(0) invert(1);
      `;
      logoHTML = logoClone.outerHTML;
    } else {
      // Fallback to text if no logo found
      logoHTML = `
        <div style="
          text-align: center;
          color: white;
          font-weight: 900;
          font-size: 2.2rem;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
          font-family: 'Asap', sans-serif;
        ">
          <div style="font-size: 3rem; margin-bottom: 10px;">🏛️</div>
          <div style="font-size: 1.8rem; letter-spacing: 2px;">THE VAULT</div>
        </div>
      `;
    }

    // Create boost pack HTML
    envelopeContainer.innerHTML = `
      <div class="boost-pack-wrapper" style="text-align: center; position: relative;">
        <!-- Mensaje previo al booster -->
        <div class="booster-win-message" style="
          color: white;
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 18px;
          font-family: 'Asap', sans-serif;
          line-height: 1.2;
        ">
          <div style="font-size: 1.7rem; margin-bottom: 4px;">¡Premio desbloqueado!</div>
          <div style="font-size: 1.1rem; font-weight: 400; opacity: 0.9;">Toca el booster para revelar tu carta gratis.</div>
        </div>
        <!-- Boost Pack -->
        <div class="boost-pack" style="
          position: relative;
          width: 302px;
          height: 448px;
          border-radius: 12px;
          margin: 0px auto 20px;
          cursor: pointer;
          transform: scale(0.9) rotateY(180deg);
          transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          border: 2px solid rgba(255, 255, 255, 0.2);
          padding: 0;
          background: linear-gradient(165deg,rgba(10, 10, 10, 1) 0%, rgba(61, 61, 61, 1) 3%, rgba(3, 2, 2, 1) 6%, rgba(250, 250, 250, 1) 11%, rgba(20, 19, 19, 1) 12%, rgba(50, 50, 87, 1) 29%, rgba(94, 94, 94, 1) 32%, rgba(16, 16, 46, 1) 40%, rgba(128, 124, 124, 1) 46%, rgba(0, 0, 0, 1) 49%, rgba(76, 88, 110, 1) 67%, rgba(23, 21, 21, 1) 73%, rgba(94, 88, 88, 1) 76%, rgba(0, 0, 0, 1) 79%, rgba(66, 65, 65, 1) 100%);
          backdrop-filter: blur(12px);
          box-shadow: rgba(255, 215, 0, 0.2) 0px 10px 16px -8px, rgba(255, 215, 0, 0.4) 0px 20px 36px -14px;
          opacity: 0;
          transform-style: preserve-3d;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        ">
          <!-- Crimp Top -->
          <div style="
            width: 100%;
            height: 14px;
            margin: 0 auto;
            border-radius: 8px 8px 0 0;
            background: repeating-linear-gradient(90deg, #bcbcbc59 0px, #bcbcbc52 2px, #e0e0e054 2px, #e0e0e063 4px);
            box-shadow: 0 2px 4px rgba(0,0,0,0.08);
            margin-top: 4px;
          ">&nbsp;</div>
          <!-- The Vault Logo -->
          <div class="vault-logo" style="
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
          ">
            ${logoHTML}
          </div>
          <!-- Crimp Bottom -->
          <div style="
            width: 100%;
            height: 14px;
            margin: 0 auto;
            border-radius: 0 0 8px 8px;
            background: repeating-linear-gradient(90deg, #bcbcbc59 0px, #bcbcbc52 2px, #e0e0e054 2px, #e0e0e063 4px);
            box-shadow: 0 -2px 4px rgba(0,0,0,0.08);
            margin-bottom: 4px;
          ">&nbsp;</div>
        </div>

        <!-- Desglose de probabilidades (VAU-236). Visible sin abrir el sobre. -->
        ${this.renderProbabilidadesHTML()}

        <!-- Instructions -->
        <div class="boost-instructions" style="
          color: white;
          font-size: 1.4rem;
          font-weight: 600;
          margin-bottom: 20px;
          top: 20px;
          position: relative;
          z-index: 10;
          font-family: 'Asap', sans-serif;
        "></div>
        
        <!-- Card container (hidden initially) -->
        <div class="card-container" style="
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: none;
          opacity: 0;
          transition: opacity 0.6s ease;
          z-index: 10;
        ">
          <div class="gift-card" style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) translateY(50px) rotateY(180deg);
            height: 418px;
            width: 302px;
            background: linear-gradient(45deg, #667eea, #764ba2);
            border-radius: 12px;
            display: block !important;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: bold;
            font-size: 2rem;
            box-shadow: rgba(255, 215, 0, 0.2) 0px 10px 16px -8px, rgba(255, 215, 0, 0.4) 0px 20px 36px -14px;
            opacity: 0;
            transition: all 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            transform-style: preserve-3d;
            border: 2px solid rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(12px);
            background-image: url('${giftCard.featured_image}'), linear-gradient(45deg, #667eea, #764ba2);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          "></div>
        </div>
      </div>
    `;

    // Show envelope container
    envelopeContainer.style.opacity = '1';
    envelopeContainer.style.display = 'flex';
    
    // Animate boost pack entrance
    setTimeout(() => {
      const boostPack = envelopeContainer.querySelector('.boost-pack');
      if (boostPack) {
        boostPack.style.opacity = '1';
        boostPack.style.transform = 'scale(0.9) rotateY(0deg)';
      }
    }, 200);

    // Get elements
    const boostPack = envelopeContainer.querySelector('.boost-pack');
    const cardContainer = envelopeContainer.querySelector('.card-container');
    const giftCardElement = envelopeContainer.querySelector('.gift-card');
    const instructions = envelopeContainer.querySelector('.boost-instructions');

    // Add click event to boost pack
    boostPack.addEventListener('click', () => {
      // Animate boost pack opening
      boostPack.style.transform = 'scale(1.1)';
      
      // Add a "ripple" effect to simulate opening
      boostPack.style.boxShadow = `
        rgba(255, 215, 0, 0.4) 0px 10px 16px -8px, 
        rgba(255, 215, 0, 0.8) 0px 20px 36px -14px,
        0 0 30px rgba(255, 215, 0, 0.8)
      `;
      
      // Hide boost pack and show card
      setTimeout(() => {
        // Hide boost pack
        boostPack.style.opacity = '0';
        boostPack.style.transform = 'scale(0.8) rotateY(180deg)';
        
        // Hide or remove the win message
        const winMsg = envelopeContainer.querySelector('.booster-win-message');
        if (winMsg) winMsg.style.display = 'none';
        // Show card container
        cardContainer.style.display = 'block';
        
        // Fade in the container first
        setTimeout(() => {
          cardContainer.style.opacity = '1';
          
          // Then animate the card with twist effect
          setTimeout(() => {
            giftCardElement.style.transform = 'translate(-50%, -50%) translateY(0) rotateY(0deg)';
            giftCardElement.style.opacity = '1';
          }, 100);
        }, 50);
        
        instructions.innerHTML = `
          <div style="font-size: 1.6rem; margin-bottom: 8px;">Carta Gratis 🎉</div>
          <div style="font-size: 1rem; opacity: 0.8;">Encontrarás esta carta en tu carrito a costo de $0</div>
          <div style="font-size: 1rem; opacity: 0.8;">Toca la carta para cerrar</div>
        `;
        
        // Add gift card to cart after animation
        setTimeout(() => {
          this.addGiftCardToCart();
          
          // Add click event to gift card to close
          giftCardElement.style.cursor = 'pointer';
          giftCardElement.addEventListener('click', () => {
            envelopeContainer.style.opacity = '0';
            setTimeout(() => {
              envelopeContainer.style.display = 'none';
            }, 500);
          });
        }, 1000);
      }, 200);
    });

    // Add hover effect
    boostPack.addEventListener('mouseenter', () => {
      boostPack.style.transform = 'scale(0.9)';
    });
    
    boostPack.addEventListener('mouseleave', () => {
      boostPack.style.transform = 'scale(0.8)';
    });
    
    // Store the gift card for later use in addGiftCardToCart
    this.currentGiftCard = giftCard;
  });
  }

  // Add gift card to cart
  addGiftCardToCart() {
    // Use the gift card that was shown in the envelope
    const giftCard = this.currentGiftCard;
    if (giftCard) {
      console.log('Adding gift card to cart:', giftCard);
        
        // Add to cart using Shopify's cart API
        const body = JSON.stringify({
          items: [{
            id: giftCard.variant_id,
            quantity: 1
          }],
          sections: [
            'cart-icon-bubble',
            'cart-drawer'
          ]
        });
        
        fetch(`${routes.cart_add_url}`, { 
          ...fetchConfig('javascript'), 
          body 
        })
        .then(response => response.text())
        .then(state => {
          const parsedState = JSON.parse(state);
          
          if (parsedState.description || parsedState.errors) {
            console.error('Error adding gift card to cart:', parsedState.description);
            this.showCartMessage('Error al agregar carta de regalo', 'error');
            return;
          }
          
          // Success! Update cart sections
          this.updateCartSections(parsedState);
          
          // Apply the discount code if available
          if (this.currentDiscountCode) {
            console.log('Applying discount code:', this.currentDiscountCode);
            this.applyDiscountCode(this.currentDiscountCode);
          }
          
          // Show success message
          this.showCartMessage(`¡${giftCard.title} agregada! 🎁`, 'success');
          
          console.log('Gift card added to cart successfully');
        })
        .catch(error => {
          console.error('Error adding gift card to cart:', error);
          this.showCartMessage('Error al agregar carta de regalo', 'error');
        });
      } else {
        console.warn('No gift card available to add');
        this.showCartMessage('No hay cartas de regalo disponibles', 'error');
      }
  }

  /**
   * Pide el sobre al servidor (ADR 193 F1).
   *
   * La ruta vieja devolvía `{ code, selectedCard }` con los campos crudos de la
   * base. La nueva devuelve lo que el sobre necesita mostrar y nada más — no
   * revela ids internos ni el resto del pool.
   *
   * Si el servidor dice que no —cuota de la IP agotada, presupuesto del día
   * gastado, pool no disponible— se devuelve null y el sobre no se abre. El
   * mensaje del servidor se muestra tal cual: sabe por qué dijo que no.
   */
  async getRandomGiftCard() {
    try {
      const response = await fetch(API_DEL_SOBRE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        console.warn('El sobre no se pudo abrir:', response.status, data);
        this.showCartMessage(data.mensaje || 'El sobre no está disponible por ahora.', 'error');
        return null;
      }

      // El código se guarda para aplicarlo cuando la carta entre al carrito.
      this.currentDiscountCode = data.codigo;
      this.compraMinima = data.compraMinima || this.compraMinima;

      return {
        id: data.codigo,
        title: data.carta.nombre,
        featured_image: data.carta.imagenUrl || IMAGEN_DE_RESPALDO,
        variant_id: String(data.carta.variantId || '').split('/').pop(),
        price: 0,
        discount_code: data.codigo,
        expiraEn: data.expiraEn,
      };
    } catch (error) {
      console.error('Error pidiendo el sobre:', error);
      this.showCartMessage('El sobre no está disponible por ahora.', 'error');
      return null;
    }
  }

  // Apply discount code to cart using the simple /discount/CODE method
  applyDiscountCode(discountCode) {
    console.log('Applying discount code to cart:', discountCode);
    
    // Use the simple /discount/CODE method that works reliably
    const discountApplyUrl = `/discount/${discountCode}`;
    
    // Create a hidden iframe to apply the discount
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.onload = () => {
      // Remove the iframe after it loads
      iframe.parentNode.removeChild(iframe);
      
      // Update cart sections to show the applied discount
      this.refreshCartSections();
      
      // Show success message
      this.showCartMessage(`¡Código ${discountCode} aplicado! 🎉`, 'success');
      
      console.log('Discount code applied successfully via iframe method');
    };
    
    iframe.onerror = () => {
      console.error('Error applying discount code via iframe');
      this.showCartMessage('Error al aplicar código de descuento', 'error');
    };
    
    iframe.src = discountApplyUrl;
    document.body.appendChild(iframe);
  }

  // Refresh cart sections to show updated discount
  refreshCartSections() {
    // Get current cart sections to update them
    fetch('/?sections=cart-icon-bubble,cart-drawer')
      .then(response => response.json())
      .then(sections => {
        // Update cart sections with new data
        Object.keys(sections).forEach(sectionId => {
          const sectionElement = document.getElementById(sectionId);
          if (sectionElement) {
            sectionElement.innerHTML = sections[sectionId];
          }
        });
      })
      .catch(error => {
        console.error('Error refreshing cart sections:', error);
      });
  }

  showRewardsProgress(message, type = 'success') {
    // Create or find message container
    let messageContainer = document.getElementById('rewards-message');
    if (!messageContainer) {
      messageContainer = document.createElement('div');
      messageContainer.id = 'rewards-message';
      messageContainer.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0.8);
        padding: 20px;
        border-radius: 8px;
        font-weight: 700;
        font-size: 1.6rem;
        z-index: 999999;
        opacity: 0;
        transition: all 0.4s ease;
        background: rgba(0, 0, 0, 0.9);
        backdrop-filter: blur(15px);
        border: 0.5px solid #ffd700;
        color: white;
        box-shadow: 0 20px 60px rgba(255, 215, 0, 0.4);
        pointer-events: auto;
        text-align: center;
        min-width: 300px;
        cursor: pointer;
      `;
      
      // Add click event to close
      messageContainer.addEventListener('click', () => {
        messageContainer.style.display = 'none';
      });
      
      document.body.appendChild(messageContainer);
    }
    
    // Set message content with close indicator
    messageContainer.innerHTML = `
      <div style="margin-bottom: 10px;">${message}</div>
      <div style="font-size: 1rem; opacity: 0.7; font-weight: 400;">Toca para cerrar</div>
    `;
    
    // Show message with scale and fade animation
    messageContainer.style.display = 'block';
    messageContainer.style.opacity = '1';
    messageContainer.style.transform = 'translate(-50%, -50%) scale(1)';
    
    // Don't auto-hide - let user close manually
  }

  // Check if a product is already in the cart
  checkIfProductInCart(variantId) {
    // This would need to be implemented based on your cart structure
    // For now, we'll return null to add normally
    return null;
  }
  
  // Update cart item quantity
  updateCartItemQuantity(itemKey, newQuantity) {
    const body = JSON.stringify({
      id: itemKey,
      quantity: newQuantity,
      sections: [
        'cart-icon-bubble',
        'cart-drawer'
      ]
    });
    
    fetch(`${routes.cart_change_url}`, { 
      ...fetchConfig('javascript'), 
      body 
    })
    .then(response => response.text())
    .then(state => {
      const parsedState = JSON.parse(state);
      
      if (parsedState.description || parsedState.errors) {
        console.error('Error updating cart:', parsedState.description);
        this.showCartMessage('Error al actualizar carrito', 'error');
        return;
      }
      
      // Success! Update cart sections
      this.updateCartSections(parsedState);
      
      // Track the swipe to cart
      this.trackSwipeToCart();
      
      // Show success message
      this.showCartMessage('Cantidad actualizada 🛒', 'success');
      
      console.log('Cart item quantity updated successfully');
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      this.showCartMessage('Error al actualizar carrito', 'error');
    });
  }

  showCartMessage(message, type = 'success') {
    // Create or find message container
    let messageContainer = document.getElementById('swiper-cart-message');
    if (!messageContainer) {
      messageContainer = document.createElement('div');
      messageContainer.id = 'swiper-cart-message';
      messageContainer.style.cssText = `
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%) translateY(-20px);
        padding: 8px;
        border-radius: 8px;
        font-weight: 600;

        font-size: 1.4rem;
        z-index: 999999;
        opacity: 0;
        transition: all 0.3s ease-in;
        background: rgba(0, 0, 0, 0.4);
        backdrop-filter: blur(10px);
        border: 2px solid #2ed573;
        color: white;
        box-shadow: 0 8px 32px rgba(46, 213, 115, 0.3);
        pointer-events: none;
        text-align: center;
        min-width: 200px;
      `;
      document.body.appendChild(messageContainer);
    }
    
    // Set message content and style
    messageContainer.textContent = message;
    
    // Adjust border color based on type
    if (type === 'error') {
      messageContainer.style.border = '2px solid #ff4757';
      messageContainer.style.boxShadow = '0 8px 32px rgba(255, 71, 87, 0.3)';
    } else {
      messageContainer.style.border = '2px solid #2ed573';
      messageContainer.style.boxShadow = '0 8px 32px rgba(46, 213, 115, 0.3)';
    }
    
    // Show message with fade in down animation
    messageContainer.style.opacity = '1';
    messageContainer.style.transform = 'translateX(-50%) translateY(0)';
    
    // Hide message after 1 second with fade out up animation (total 1.5s cycle)
    setTimeout(() => {
      messageContainer.style.opacity = '0';
      messageContainer.style.transform = 'translateX(-50%) translateY(-20px)';
    }, 1000);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.productSwiper = new ProductSwiper();
}); 

// Global function for restart button
window.restartSwiper = function() {
  if (window.productSwiper) {
    window.productSwiper.restart();
  }
}; 